import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { GridCellStack } from "@ui/components/grid";
import { Icon } from "@iconify/react";
import { FreeRoamingBadge } from "@ui/components/badges/FreeRoamingBadge";
import TemperatureDisplay from "@ui/components/temperature/TemperatureDisplay";
import { getNodeTemperatureColor } from "@ui/components/temperature";
import { formatUtcToLocalDate, formatUtcToLocalTime, } from "@application/common/helpers/date-util";
import { useTranslation } from "react-i18next";
import { MobileCard } from "@ui/components/card";
import { SMenu } from "@ui/components/menu/SMenu";
import { SIconButton } from "@ui/components/buttons";
import { IconText } from "@ui/components/info/IconText";
import { PermissionChecker, Permission } from "@utility/permission-checker";
import { StatusIndicator } from "@ui/components/status/StatusIndicator";
export const NodeCard = ({ row, onDisconnect, onDelete, onLogs, onEdit, onApConfig, onClick, }) => {
    var _a, _b;
    const { t } = useTranslation(["common"]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isDisconnected = !((_a = row.deviceId) === null || _a === void 0 ? void 0 : _a.trim());
    const handleMenuOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const menuItems = [
        ...(PermissionChecker.hasPermission(Permission.ACCESSPOINTS_DELETE) &&
            !isDisconnected
            ? [
                {
                    label: t("common:actions.disconnect"),
                    onClick: () => onDisconnect(row),
                    color: "error",
                },
            ]
            : []),
        ...(PermissionChecker.hasPermission(Permission.NODES_DELETE)
            ? [
                {
                    label: t("common:actions.delete"),
                    onClick: () => onDelete(row),
                    color: "error",
                },
            ]
            : []),
        {
            label: t("common:actions.logs"),
            onClick: () => onLogs(row.nodeId, row.deviceId),
        },
        ...(PermissionChecker.hasPermission(Permission.NODES_EDIT)
            ? [
                {
                    label: t("common:actions.edit"),
                    onClick: () => onEdit(row.id),
                },
            ]
            : []),
        ...(PermissionChecker.hasPermission(Permission.ACCESSPOINTS_EDIT)
            ? [
                {
                    label: "AP",
                    onClick: () => onApConfig(row.deviceId),
                },
            ]
            : []),
    ];
    return (React.createElement(MobileCard, { onClick: onClick ? () => onClick(row.deviceId) : undefined },
        React.createElement(Box, { sx: { display: "flex", alignItems: "flex-start", gap: 1 } },
            React.createElement(Box, { sx: { flexShrink: 0 } },
                React.createElement(TemperatureDisplay, { width: 91, temperature: (_b = row === null || row === void 0 ? void 0 : row.nodeTemperature) !== null && _b !== void 0 ? _b : null, color: getNodeTemperatureColor(row !== null && row !== void 0 ? row : {}) })),
            React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                row.freeRoamingNode && (React.createElement(Box, { sx: { mb: 0.5 } },
                    React.createElement(FreeRoamingBadge, null))),
                React.createElement(GridCellStack, { topText: row.nodeName, bottomText: row.nodeId, topStyle: { fontWeight: 600, lineHeight: "22px" }, bottomVariant: "caption", bottomColor: "text.secondary" }),
                React.createElement(StatusIndicator, { variant: row.isActive ? "active" : "inactive" })),
            React.createElement(SIconButton, { size: "small", colorVariant: "inherit", showBackground: false, onClick: handleMenuOpen },
                React.createElement(Icon, { icon: "eva:more-vertical-fill", color: "#231F20" })),
            React.createElement(SMenu, { anchorEl: anchorEl, open: Boolean(anchorEl), handleClose: () => setAnchorEl(null), menuItems: menuItems })),
        React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 0.5 } },
            React.createElement(Icon, { icon: "mdi:router-wireless", width: 18, color: "#637381" }),
            React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true }, row.deviceName),
            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "\u00B7"),
            React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true },
                "AP#",
                row.deviceId)),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:calendar-linear", text: formatUtcToLocalDate(row.lastUpdate) })),
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:clock-circle-linear", text: formatUtcToLocalTime(row.lastUpdate) })))));
};
